// action types for the pre contracts
export const SET_PRECONTRACTS_LIST = "SET_PRECONTRACTS_LIST";
export const SET_PRECONTRACT = "SET_PRECONTRACT";
export const SET_PRECONTRACT_ITEMS = "SET_PRECONTRACT_ITEMS";
export const SET_PRECONTRACT_ITEM = "SET_PRECONTRACT_ITEM";
export const RESET_PRECONTRACT_ITEM = "RESET_PRECONTRACT_ITEM";
